import { Column } from 'react-table';
import styled from '@emotion/styled';
import { Label } from '@britishcouncil/react-admin';
import { LifeSkillsCertificationInformation } from 'api';
import { formatDate } from 'utils';
import { CheckIcon, ViewDetailsButton } from 'components';
import { getLifeSkillsLevelName } from 'const/life-skills-level/lifeSkillsLevelHelpers';

export const COLUMNS: Column<LifeSkillsCertificationInformation>[] = [
  {
    Header: 'Date of Certification',
    accessor: 'dateOfCertification',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Level',
    accessor: 'lifeSkillsLevel',
    Cell: ({ value }) => <>{getLifeSkillsLevelName(value)}</>,
  },
  {
    Header: 'Set',
    accessor: 'lifeSkillsCertificationSetName',
  },
  {
    Header: 'Pass Indicator',
    accessor: 'isPassed',
    Cell: ({ value }) => (
      <S.LabelWrapper>
        <Label color={value ? 'green' : 'red'}>{value ? 'Pass' : 'Fail'}</Label>
      </S.LabelWrapper>
    ),
  },
  {
    Header: 'IDP',
    accessor: 'isFromIdp',
    width: '100px',
    Cell: CheckIcon,
  },
  {
    Header: '',
    accessor: 'id',
    width: '60px',
    Cell: ({ value }) => <ViewDetailsButton to={value} />,
  },
];

const S = {
  LabelWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
};
